import IOrder from "@models/IOrder";
import React from "react";

type Props = {
    orderModel: IOrder;
};

export const OrderPaymentAuthorizeNetExistingCard = (props: Props) => {
    return <div className={"OrderPaymentAuthorizeNetExistingCard"}></div>;
};
